// extracted by mini-css-extract-plugin
module.exports = {"container":"Page_container__1ZKtQ"};